import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from './components/Header';
import { AcademyMain } from './components/AcademyMain';

function Academy() {
  return (
    <div className="App">
      <Header />
      <AcademyMain />
    </div>
  );
}

export default Academy;
